module.exports = "/_next/static/images/app_store_badge_white-0f3514a45d51f95167e5fe8b6a03bb60.svg";